import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, CheckCircle, ArrowRight } from 'lucide-react';
import { useContact } from '../../context/ContactContext';
import AnimatedBadge from '../ui/AnimatedBadge';

export default function DomesticIrpfSection() {
  const { openModal } = useContact();
  return (
    <section id="esocial" className="w-full bg-background py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center lg:text-left"
          >
            <div className="mb-4 md:mb-6 flex justify-center lg:justify-start">
              <AnimatedBadge>
                eSocial Sem Complicação
              </AnimatedBadge>
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-foreground tracking-tight mb-6 md:mb-8 leading-tight">
              Tranquilidade para sua <br className="hidden md:block" /> Família e Empregados.
            </h2>
            <p className="text-sm md:text-lg text-slate-400 font-medium mb-8 md:mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0">
              Gerenciar empregados domésticos não precisa ser burocrático. Nossa equipe garante que você esteja 100% em dia com a lei eSocial.
            </p>
            
            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10 inline-block text-left">
              {["Cálculo automático de guias DAE", "Gestão de férias e afastamentos", "Rescisões e contratos jurídicos"].map((item, idx) => (
                <li key={idx} className="flex items-center gap-3 text-slate-300 font-medium text-xs md:text-base">
                  <CheckCircle size={16} className="text-orange-500" />
                  {item}
                </li>
              ))}
            </ul>

            <div className="flex justify-center lg:justify-start px-6 md:px-0">
              <a 
                href="https://wa.me/5511949830659"
                rel="noopener noreferrer"
                className="w-full sm:w-[240px] px-10 py-4 bg-orange-600 hover:bg-orange-500 text-white font-bold rounded-full transition-all flex items-center justify-center gap-2 uppercase tracking-widest text-[10px] whitespace-nowrap"
              >
                Regularizar Agora
                <ArrowRight size={16} />
              </a>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div className="relative z-10 rounded-[2rem] overflow-hidden border border-foreground/10 aspect-video shadow-2xl max-w-lg mx-auto">
              <img 
                src="https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&q=80" 
                alt="Gestão eSocial" 
                className="w-full h-full object-cover"
              />
            </div>
            {/* Float Badge */}
            <motion.div 
              animate={{ 
                y: [0, -10, 0],
              }}
              transition={{
                duration: 5,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-white p-4 md:p-6 rounded-2xl shadow-2xl z-20 border border-slate-100"
            >
              <div className="flex items-center gap-3">
                <Smartphone className="w-5 h-5 md:w-6 md:h-6 text-orange-600" />
                <div className="text-left">
                  <p className="text-slate-900 font-black text-[10px] md:text-sm uppercase">100% Digital</p>
                  <p className="text-slate-500 text-[8px] md:text-[10px] font-bold">Acesso via Portal</p>
                </div>
              </div>
            </motion.div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
